module.exports = __webpack_public_path__ + "static/media/Pit Pay Stacked.8a302a7a.svg";